import React from 'react';
import PropTypes from 'prop-types';

import ProductBundleHeader from './ProductBundleHeader';
import ProductBundleProducts from './ProductBundleProducts';
import ProductBundleNav from './ProductBundleNav';
import TermsConditions from './TermsConditions';
import CovidRelief from './CovidRelief';
import Container from 'kepler/lib/components/Container';
import { get, throttle, extend } from 'lodash';
import {
  NAV_TABS,
  getNonStickyHeaderStyles,
  getBundles
} from '../lib/productBundlesStaticMapping';

class ProductBundle extends React.Component {
  constructor(props) {
    super(props);
    let productcompletion = get(props, 'productcompletion', {}),
      experimentation = get(props, 'experimentation', {});
    let bundles = getBundles(
      get(props, 'app.legalCountry', 'US'),
      productcompletion,
      experimentation
    );
    this.state = {
      sticky: false,
      selectedNavItem: NAV_TABS.RAISE_FINANCIAL_SUPPORT,
      bundles,
      bundlesKeys: Object.keys(bundles)
    };
  }

  componentDidMount = () => {
    const { experimentation, fptiHelper } = this.props,
      throttleCheckMobile = throttle(this.trackScrolling, 100);
    document.addEventListener('scroll', throttleCheckMobile);
    this.covidNav = document.getElementsByClassName('covid-nav')[0];
    this.covidContentContainer = document.getElementsByClassName(
      'covid-container'
    )[0];
    this.extraPPCPNav = get(experimentation, 'ppcp.newNav', false);
    this.extraPPCPNavAdjustment = this.extraPPCPNav;
    fptiHelper.fptiImpression({ page: 'main:merchanthub:productbundle:main' });
    if (this.covidNav) {
      this.covidNav.classList.add('sticky');
      this.stickyHeight = this.covidNav.offsetHeight;
      this.covidNav.classList.remove('sticky');
    }
  };

  trackScrolling = () => {
    let elementTarget, adjustment;
    elementTarget = this.covidNav;
    adjustment = elementTarget.offsetTop;
    if (window.innerWidth <= 886) this.extraPPCPNavAdjustment = false;
    else this.extraPPCPNavAdjustment = this.extraPPCPNav;
    if (window.scrollY > adjustment) {
      this.setState({ sticky: true });
      this.covidNav.classList.add('sticky');
      if (this.extraPPCPNavAdjustment) {
        this.covidNav.classList.add('extraPPCPNav');
      }
      this.covidContentContainer.style.marginTop = '150px';
      //As you are scrolling highlight the correct section in the Nav
      this.checkIfSectionIsScrolled(this.covidNav);
    } else {
      this.setState({ sticky: false });
      this.covidContentContainer.style.marginTop = '0px';
      this.covidNav.classList.remove('sticky');
    }
  };

  checkIfSectionIsScrolled = nav => {
    const { bundlesKeys } = this.state;
    let selectedNav;
    bundlesKeys.forEach(key => {
      let bundleOffset = document.getElementById(key).offsetTop;
      if (this.extraPPCPNavAdjustment) bundleOffset -= 60;
      else bundleOffset -= 25;
      if (window.scrollY + nav.offsetHeight > bundleOffset) {
        selectedNav = key;
        this.setState({ selectedNavItem: key });
      }
      //In the mobile view the nav is scrollable, so scroll that as well as you reach the corresponding sections
      if (window.innerWidth < 1073 && selectedNav) {
        document
          .getElementsByClassName(`covid-nav-item-content-${selectedNav}`)[0]
          .scrollIntoView({ inline: 'start' });
      }
    });
  };

  onClickNavItem = bundleId => {
    const { selectedNavItem } = this.state,
      covidStickyNav = document.getElementsByClassName('sticky')[0],
      { app } = this.props;
    if (selectedNavItem !== bundleId || !covidStickyNav) {
      document.getElementById(bundleId).scrollIntoView();
      //-70 is the mep header adjustment and the padding-top adjustment
      let adjustment =
          -document.getElementsByClassName('covid-nav')[0].offsetHeight - 70,
        stickyNav = document.getElementsByClassName('sticky')[0];
      if (window.innerWidth <= 1073 && !stickyNav) {
        //height of mep header and sticky nav adjustments
        adjustment += 70;
      }
      if (window.innerWidth > 1073 && !stickyNav) {
        //padding adjustment
        adjustment += 35;
      }

      if (this.extraPPCPNavAdjustment && !stickyNav) adjustment -= 50;
      if (this.extraPPCPNavAdjustment && stickyNav) adjustment -= 55;
      if (this.stickyHeight >= 114 && !stickyNav && window.innerWidth > 1073)
        adjustment -= 47;

      let scrollByObj = {
        top: adjustment,
        left: 0
      };

      if (get(app, 'deviceInfo.browserName', '') === 'Chrome') {
        extend(scrollByObj, { behavior: 'smooth' });
      }

      window.scrollBy(scrollByObj);
    }
  };

  render() {
    const { selectedNavItem, sticky, bundles } = this.state,
      styles = getNonStickyHeaderStyles(sticky);
    const { app, fptiHelper, productcompletion } = this.props;
    return (
      <div id="covid">
        <ProductBundleHeader />
        <div className="covid-nav-separate" style={styles}>
          <ProductBundleNav
            onClickNavItem={this.onClickNavItem}
            sticky={sticky}
            selectedNavItem={selectedNavItem}
            bundles={bundles}
          />
        </div>
        <Container className="covid-container">
          <ProductBundleProducts
            bundles={bundles}
            app={app}
            fptiHelper={fptiHelper}
            productcompletion={productcompletion}
          />
          <CovidRelief app={app} fptiHelper={fptiHelper} />
          <TermsConditions bundles={bundles} app={app} />
        </Container>
      </div>
    );
  }
}

ProductBundle.propTypes = {
  app: PropTypes.object,
  productcompletion: PropTypes.object,
  fptiHelper: PropTypes.object,
  experimentation: PropTypes.object
};

export default ProductBundle;
